import {useTaopix} from '../Components/Context/TaopixContext';
import {useEffect, useState} from 'react';
import {CoreEvent, ViewportState} from '@taopix/taopix-core';

const useViewportState = (): ViewportState => {
  const app = useTaopix();
  const [viewportState, setViewportState] = useState(ViewportState.Normal);

  useEffect(() => {
    const initialViewportState: ViewportState = app.core.get('utils').getViewportState();
    setViewportState(initialViewportState);

    const token = app.core.subscribe(CoreEvent.VIEWPORT_STATE_CHANGE, (msg: string, data: any) => {
      setViewportState(data);
    });

    return () => {
      app.core.unsubscribe(token);
    };
  }, []);

  return viewportState;
};

export default useViewportState;
